import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import {
  ConfigProvider, Layout, Menu, Breadcrumb, Button, Form, FormModel,
  Input, InputNumber, Select, Table, Modal, Spin, message, notification,
  Tag, Space, Divider, Tooltip, Popconfirm, Badge, Card, Row, Col,
  Dropdown, Icon, Avatar, Upload, Cascader, Radio, Checkbox, Switch,
  DatePicker, Pagination, Result, Empty, Tabs, Drawer, Descriptions
} from 'ant-design-vue'

// 按需注册组件
const components = [
  ConfigProvider, Layout, Menu, Breadcrumb, Button, Form, FormModel,
  Input, InputNumber, Select, Table, Modal, Spin, Tag, Space, Divider,
  Tooltip, Popconfirm, Badge, Card, Row, Col, Dropdown, Icon, Avatar,
  Upload, Cascader, Radio, Checkbox, Switch, DatePicker, Pagination,
  Result, Empty, Tabs, Drawer, Descriptions
]
components.forEach(c => Vue.use(c))

Vue.prototype.$message      = message
Vue.prototype.$notification = notification
Vue.prototype.$confirm      = Modal.confirm
Vue.prototype.$info         = Modal.info
Vue.prototype.$imgBase      = process.env.BASE_URL   // 图片基础路径，跟随 publicPath

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
